import ContractDropdownDTO from 'features/contracts/dtos/ContractDropdownDTO';
import SelfReadingTypeEnumDTO from "features/requirements/dtos/SelfReadingTypeEnumDTO";
import { FormValidations, ValidationActionType } from "features/shared/forms/hooks/useForm";
import { Nullable } from "features/shared/types/nullable";
import PatternValidatonRule from "features/validation/rules/PatternValidatonRule";
import ValidationRule from "features/validation/rules/ValidationRule";

type SetValidationRuleFunction = (key: string, validationRule: Nullable<ValidationRule>, action?: ValidationActionType) => void;

export const selfReadingFormValidations = (): FormValidations => {
  return {
    DESC_TMSmOdecSmlouva: {
      required: true,
      type: "OnlyRequired"
    }
  };
}

export const setTypeValidation = (setValidationRule: SetValidationRuleFunction) => {
  const rule: ValidationRule = {
    required: true,
    type: "OnlyRequired"
  };

  setValidationRule("DESC_TMSmOdecDuvod", rule);
}

export const setDependentInputsValidation = (
  setValidationRule: SetValidationRuleFunction,
  selectedContract: ContractDropdownDTO,
  selectedType?: SelfReadingTypeEnumDTO
) => {
  // self-reading date 
  const dateRule: ValidationRule = {
    required: true,
    type: "OnlyRequired",
  };
  setValidationRule("DESC_TMSmOdecDatum", dateRule);

  // self-reading meter
  setMeterValidation(setValidationRule, selectedType);

  // self-reading gas meter state
  setGasMeterValidation(setValidationRule, selectedContract);

  // self-reading electricity meter state
  setElectricityMeterHighTarifValidation(setValidationRule, selectedContract);
  setElectricityMeterLowTarifValidation(setValidationRule, selectedContract);
};

const setMeterValidation = (setValidationRule: SetValidationRuleFunction, selectedType?: SelfReadingTypeEnumDTO) => {
  if (selectedType) {
    const meterRule: PatternValidatonRule = {
      required: selectedType.idMeterRequired,
      type: "Pattern",
      regex: /^.{0,20}$/,
      enableEmptyValue: selectedType.idMeterRequired ? false : true,
      message: "selfReadingFormValidation.DESC_TMSmOdecMeridlo"
    };
    setValidationRule("DESC_TMSmOdecMeridlo", meterRule);
  } else {
    setValidationRule("DESC_TMSmOdecMeridlo", null, "remove");
  }
}

const setGasMeterValidation = (setValidationRule: SetValidationRuleFunction, selectedContract: ContractDropdownDTO) => {
  if (selectedContract.commodityDetail === "GasCustomer") {
    const meterRule: PatternValidatonRule = {
      required: true,
      type: "Pattern",
      regex: /^\d+$/,
      message: "invalidInteger"
    };
    setValidationRule("DESC_TMSmOdecStav", meterRule);
  } else {
    setValidationRule("DESC_TMSmOdecStav", null, "remove");
  }
}

const setElectricityMeterHighTarifValidation = (setValidationRule: SetValidationRuleFunction, selectedContract: ContractDropdownDTO) => {
  if (selectedContract.commodityDetail === "ElectricityCustomer") {
    const meterRule: PatternValidatonRule = {
      required: true,
      type: "Pattern",
      regex: /^\d+$/,
      message: "invalidInteger"
    };
    setValidationRule("DESC_TMSmOdecStavVT", meterRule);
  } else {
    setValidationRule("DESC_TMSmOdecStavVT", null, "remove");
  }
}

const setElectricityMeterLowTarifValidation = (setValidationRule: SetValidationRuleFunction, selectedContract: ContractDropdownDTO) => {
  if (selectedContract.commodityDetail === "ElectricityCustomer" && selectedContract.isSingleRate === false) {
    const meterRule: PatternValidatonRule = {
      required: true,
      type: "Pattern",
      regex: /^\d+$/,
      message: "invalidInteger"
    };
    setValidationRule("DESC_TMSmOdecStavNT", meterRule);
  } else {
    setValidationRule("DESC_TMSmOdecStavNT", null, "remove");
  }
}